<template>
  <div>
    <Header>
      <RecruitNav/>
    </Header>
    <body class="favorite-novel-body">
      <div class="favorite-novel-container">
        <table class="action-table" border="1" width="100%" cellspacing="0" cellpadding="5" bordercolor="#dbdbdb">
          <tr>
            <th width="50%"><font>ノベルの著者</font></th>
            <th width="50%"><font>ノベル名</font></th>
          </tr>
          <tr v-for="(s, i) in storyProfileFavorite"
              @click="$router.push({path: `/recruits/story/${s.company_id}/${s.story_id}`})"
              :key="i" class="finish-reading">
            <td valign="top">{{s.company_name}}</td>
            <td valign="top">{{s.story_title}}</td>
          </tr>
        </table>
      </div>
    </body>
  </div>
</template>

<script>
import Header from '@/components/layouts/Header'
import RecruitNav from '@/views/Recruit/RecruitNav'
import { mapState } from 'vuex'

export default {
  name: 'FavoriteNovel',
  componentName: 'FavoriteNovel',
  components: {
    Header,
    RecruitNav
  },
  computed: {
    ...mapState('chatbot', ['storyProfileFavorite']),
  },
  mounted() {
    this.getStoryProfileFavorite()
  },
  methods: {
    getStoryProfileFavorite() {
      this.$store.dispatch('chatbot/getStoryProfileFavorite')
    }
  }
}
</script>

<style lang="scss" scoped>
.favorite-novel-body {
  background-color: #f8f8f8;
  height: calc(100vh - 80px);
  width: 100%;
  padding-top: 40px;
}
.favorite-novel-container {
  width: 80%;
  height: 480px;
  overflow: scroll;
  position: relative;
  margin: auto;
}
.favorite-novel-container::-webkit-scrollbar {
  width:  10px;
  height: 10px;
  visibility: hidden;
}
.action-table {
  margin: auto;
  background: #fff;
  table-layout: fixed;
  th, td {
    font-size: 14px;
    padding: 8px;
  }
}
.finish-reading {
  cursor: pointer;
}
.finish-reading:hover {
  background: #ffeef8;
}
.finish-reading-comment-wrapper {
  border: 1px solid #dbdbdb;
  padding: 16px;
  text-align: left;
  border-radius: 5px;
  min-height: 400px;
  font-size: 14px;
}
.arrow-left-wrapper {
  text-align: left;
  margin-bottom: 8px;
  i {
    cursor: pointer;
  }
}
// ヘッダーだけ固定したいが、うまくいかない
th {
  position: sticky;
  top: 0;
  background: #dbdbdb;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/views/Recruit/FavoriteNovel.vue